import React from "react";
import HeaderSearch from "../../../../common/components/HeaderSearch";
import GetCompensationContextProvider, {
  ACTIONS,
  GetCompensationContext,
} from "../../context/GetCompensationContextProvider";
import Loading from "../../../../common/components/Loading";
import { CGE } from "../../../../common/components/CGE";

const GetCompensationPriv = ({
  titleCompensation,
  description,
  options,
  textFetchError,
  textAlertFilledField,
  setGlobalAlert
}) => {
  const [loading, setLoading] = React.useState(false);
  const [state, dispatch] = React.useContext(GetCompensationContext);
  const [inputSearch, setInputSearch] = React.useState("");
  const [inputSelected, setInputSelected] = React.useState("");
  const [yearSelected, setYearSelected] = React.useState("");
  const [errorToggle, setErrorToggle] = React.useState(false);
  let data = state.idList ? state.idList : [];

  function handleChange(e) {
    setYearSelected(e.target.value);
  }

  function handleClickButton() {

    if (inputSelected && yearSelected) {
      setLoading(true);
      setErrorToggle(false)
      dispatch({
        payload: [inputSelected, yearSelected],
        type: ACTIONS.SET_CURRENT_ARRAY,
      })
    } else {
      setGlobalAlert(textAlertFilledField, "warning");
      setErrorToggle(true)
      dispatch({
        payload: [],
        type: ACTIONS.SET_CURRENT_ARRAY,
      })
      if(!inputSelected) {
      setGlobalAlert("Debes ingresar un Nro. de Cliente", "warning");
      }
    }
  }

  React.useEffect(() => {
    setLoading(true);
    dispatch({
      payload: true,
      type: ACTIONS.SET_LOAD_PAGE,
    });
  }, []);

  React.useEffect(() => {
    if (state.idList) {
      setTimeout(() => {
        setLoading(false);
      }, 400);
    }
  }, [state.idList]);

  React.useEffect(() => {
    if (inputSearch !== "") {
      if (data.find((o) => o === inputSearch)) {
        setInputSelected(inputSearch);
        document.getElementById("mySelectId").value = inputSearch;
      }
    }
  }, [inputSearch]);

  React.useEffect(() => {
    if (inputSelected) {
      dispatch({
        payload: inputSelected,
        type: ACTIONS.SET_IDCLIENT,
      });
      setInputSearch("");
    } else {
      setInputSelected("");

      document.getElementById("mySelectId").value = "";
      dispatch({
        payload: "",
        type: ACTIONS.SET_IDCLIENT,
      });
    }
  }, [inputSelected]);

  React.useEffect(() => {
    setLoading(false);
  }, [state.responseCompensation, state.errorFetch]);

  React.useEffect(() => {
    if (state.responseCompensation?.status === 500) {
      setGlobalAlert(textFetchError, "warning", true, "Advertencia");
    } else if (state.responseCompensation?.message) {
      setGlobalAlert(state.responseCompensation?.message, "warning", true, "Advertencia");
    }
  }, [state.responseCompensation]);

  return (
    <>
      <HeaderSearch
        data={data}
        setSearch={setInputSearch}
        setSelected={setInputSelected}
        idClient={inputSelected}
        inputSearch={inputSearch}
      />
      <CGE.Panel title={titleCompensation} description={description}>
        <div className="d-flex align-items-center flex-column">
          <CGE.PanelContainer
            alingItensCenter={true}
            size="md"
          >
            <CGE.FormsField
              handleChange={(e) => handleChange(e)}
              horizontal={true}
              idFormElement="mySelectYear"
              labelName="Año: "
              listOptions={options}
              mandatoryElement={true}
              style={{ background: '#fff' }}
              typeElement="select"
              typeFormElement="text"
              hasError={errorToggle && !yearSelected}
              msgError="Debes seleccionar un año"
            />
          </CGE.PanelContainer>
          <CGE.Button
            label="Generar Cartola"
            onClick={() => handleClickButton()}
            type="primary"
          />
        </div>
        {loading && <Loading />}
      </CGE.Panel>
    </>
  );
};

const GetCompensationWithProvider = ({
  titleCompensation,
  description,
  options,
  qtdRowPage,
  textFetchError,
  textLoadingBoleta,
  textFetchNoId,
  textAlertExcel,
  textAlertFilledField,
  setGlobalAlert
}) => (
  <GetCompensationContextProvider>
    <GetCompensationPriv
      titleCompensation={titleCompensation}
      description={description}
      options={options}
      qtdRowPage={qtdRowPage}
      textFetchError={textFetchError}
      textLoadingBoleta={textLoadingBoleta}
      textFetchNoId={textFetchNoId}
      textAlertExcel={textAlertExcel}
      textAlertFilledField={textAlertFilledField}
      setGlobalAlert={setGlobalAlert}
    />
  </GetCompensationContextProvider>
);

export default GetCompensationWithProvider;